import { registerSectionType } from "../../utils/sectionRegistry";

registerSectionType({
  type: "encabezado",
  label: "Encabezado",
  layout: "simple",
  previewBlocks: ["Titulo", "Subtitulo", "Descripcion"],
  getDefaults: () => ({ type: "encabezado", title: "", subtitle: "", description: "" }),
  render: (section, index) => (
    <section key={`hero-${index}`} className="dynamic-section dynamic-section-hero">
      <h1>{section?.title || "Página"}</h1>
      {section?.subtitle ? <p className="dynamic-subtitle">{section.subtitle}</p> : null}
      {section?.description ? <p className="dynamic-description">{section.description}</p> : null}
    </section>
  ),
});
